import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  Box,
  Button,
  ButtonGroup,
  Grid,
  TextField,
  Typography,
  FormControl,
  Select,
  Checkbox,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Menu,
  FormControlLabel,
  makeStyles,
} from "@material-ui/core";
import { Save as SaveIcon } from "@material-ui/icons";
import { DatePicker } from "@material-ui/pickers";

import useMenu from "../../../../hooks/useMenu";
import { startOfMonth, endOfDay, startOfDay, addMonths } from "date-fns";

const useStyles = makeStyles((theme) => ({
  paper: {
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "80%",
    },
  },
}));

export default function SearchForm({dateType, formData, setFormData}) {
    const dispatch = useDispatch();
    const classes = useStyles();
    const [errors, setErrors] = useState({ start: "", end: "" });

    const greenMenu = useMenu();
    const materialMenu = useMenu();
    
    const utilsData = useSelector((state) => state.utils);
    const greenPoints = utilsData.greenPoints || [];
    const materialsObj = utilsData.materials || {};
    const materials = Object.values(materialsObj).map(m => ({
        _id: m._id,
        name: m.name,
        key: m.key,
    }));

    const [initialized, setInitialized] = useState({ locals: false, materials: false });

    const checkAllGreenPoints = () => {
        setFormData(prev => {     
            const allSelected = prev.locals.length === greenPoints.length;
            return {
                ...prev,
                locals: allSelected ? [] : greenPoints.map(gp => gp.name)
            };
        });
    };

    const checkGreenPoint = (id) => {
        const gp = greenPoints.find(g => g._id === id);
        if (!gp) return;

        setFormData(prev => {
            const exists = prev.locals.includes(gp.name);
            return {
                ...prev,
                locals: exists
                    ? prev.locals.filter(name => name !== gp.name)
                    : [...prev.locals, gp.name]
            };
        });
    };

    const checkAllMaterials = () => {
        setFormData(prev => {
            const allSelected = prev.materials.length === materials.length;
            return {
                ...prev,
                materials: allSelected ? [] : materials.map(m => m.name)
            };
        });
    };

    const checkMaterial = (id) => {
        const mat = materials.find(m => m._id === id);
        if (!mat) return;

        setFormData(prev => {
            const exists = prev.materials.includes(mat.name);
            return {
                ...prev,
                materials: exists
                    ? prev.materials.filter(name => name !== mat.name)
                    : [...prev.materials, mat.name]
            };
        });
    };

    const handleStartDateChange = (d) => {
        if (!d) return;
        const jsDate = d instanceof Date ? d : new Date(d);

        const newDate = dateType
            ? startOfDay(jsDate)
            : startOfDay(new Date(jsDate.getFullYear(), jsDate.getMonth(), 1));

        setFormData(prev => ({ ...prev, dateInit: newDate }));

        if (formData.dateFinish && newDate > formData.dateFinish) {
            setErrors(prev => ({ ...prev, start: "La fecha inicial debe ser menor a la final" }));
        } else {
            setErrors(prev => ({ ...prev, start: "" }));
        }
    };

    const handleEndDateChange = (d) => {
        if (!d) return;
        const jsDate = d instanceof Date ? d : new Date(d);

        const newDate = dateType
            ? endOfDay(jsDate)
            : endOfDay(new Date(jsDate.getFullYear(), jsDate.getMonth(), 1));

        setFormData(prev => ({ ...prev, dateFinish: newDate }));

        if (formData.dateInit && newDate < formData.dateInit) {
            setErrors(prev => ({ ...prev, end: "La fecha final debe ser mayor a la inicial" }));
        } else {
            setErrors(prev => ({ ...prev, end: "" }));
        }
    };

    useEffect(() => {
        if (greenPoints.length > 0 && !initialized.locals) {
            setFormData(prev => ({
                ...prev,
                locals: greenPoints.map(gp => gp.name)
            }));
            setInitialized(prev => ({ ...prev, locals: true }));
        }

        if (materials.length > 0 && !initialized.materials) {
            setFormData(prev => ({
                ...prev,
                materials: materials.map(m => m.name)
            }));
            setInitialized(prev => ({ ...prev, materials: true }));
        }
    }, [greenPoints, materials]);

    useEffect(() => {
        const today = new Date();
        const startMonth = startOfMonth(today);

        if (dateType) {
            setFormData(prev => ({
                ...prev,
                dateInit: startMonth,
                dateFinish: endOfDay(today)
            }));
        } else {
            const nextMonthStart = startOfMonth(addMonths(today, 1));
            setFormData(prev => ({
                ...prev,
                dateInit: startMonth,
                dateFinish: nextMonthStart
            }));
        }
    }, [dateType]);



    return (
        <>
            <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                    <Box>
                        <Typography variant="h6">Puntos Gira</Typography>
                        <TextField
                            label={`${greenPoints.length} Puntos Gira encontrados`}
                            variant="outlined"
                            fullWidth
                            margin="dense"
                            onClick={greenMenu.handleOpen}
                            value={`${formData.locals.length} seleccionados`}
                        ></TextField>
            
                        <Menu
                            open={greenMenu.open}
                            anchorEl={greenMenu.anchorEl}
                            keepMounted
                            onClose={greenMenu.handleClose}
                            classes={{ paper: classes.paper }}
                        >
                            <Box p={2}>
                                <Box padding="5px 10px">
                                    <Typography style={{ fontWeight: "bold" }}>
                                        PUNTOS GIRA
                                    </Typography>
                                </Box>
                                <Grid container spacing={1}>
                                    <Grid item xs={6} md={4}>
                                    <MenuItem>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={
                                                        formData.locals.length === greenPoints.length
                                                    }
                                                    color="primary"
                                                    onChange={checkAllGreenPoints}
                                                />
                                            }
                                            label={"Todos"}
                                        />
                                    </MenuItem>
                                    </Grid>
                                    {greenPoints.map((greenPoint) => (
                                        <Grid item xs={6} md={4} key={greenPoint._id}>
                                            <MenuItem>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={formData.locals.includes(greenPoint.name)}
                                                        color="primary"
                                                        onChange={() => checkGreenPoint(greenPoint._id)}
                                                    />
                                                }
                                                label={greenPoint.name}
                                            />
                                            </MenuItem>
                                        </Grid>
                                    ))}
                                </Grid>
                            </Box>
                        </Menu>
                    </Box>
                </Grid>

                <Grid item xs={12} md={6}>
                    <Box>
                        <Typography variant="h6">Materiales</Typography>
                        <TextField
                            label={`${materials.length} Materiales encontrados`}
                            variant="outlined"
                            fullWidth
                            margin="dense"
                            onClick={materialMenu.handleOpen}
                            value={`${formData.materials.length} seleccionados`}
                        />
                        <Menu
                            open={materialMenu.open}
                            anchorEl={materialMenu.anchorEl}
                            keepMounted
                            onClose={materialMenu.handleClose}
                            classes={{ paper: classes.paper }}
                        >
                            <Box p={2}>
                                <Typography style={{ fontWeight: "bold" }}>MATERIALES</Typography>
                                <Grid container spacing={1}>
                                    <Grid item xs={6} md={4}>
                                        <MenuItem>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={formData.materials.length === materials.length}
                                                        color="primary"
                                                        onChange={checkAllMaterials}
                                                    />
                                                }
                                                label="Todos"
                                            />
                                        </MenuItem>
                                    </Grid>
                                    {materials.map((mat) => (
                                        <Grid item xs={6} md={4} key={mat._id}>
                                            <MenuItem>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={formData.materials.includes(mat.name)}
                                                            color="primary"
                                                            onChange={() => checkMaterial(mat._id)}
                                                        />
                                                    }
                                                    label={mat.name}
                                                />
                                            </MenuItem>
                                        </Grid>
                                    ))}
                                </Grid>
                            </Box>
                        </Menu>
                    </Box>
                </Grid>

                <Grid item xs={12} md={6}>
                    <DatePicker
                        views={dateType ? ["year", "month", "date"] : ["year", "month"]}
                        inputVariant="outlined"
                        margin="dense"
                        fullWidth
                        label="Fecha inicio"
                        format={dateType ? "DD/MM/yyyy" : "MM/yyyy"}
                        value={formData.dateInit || null}
                        onChange={handleStartDateChange}
                    />
                    {errors.start && (
                        <Typography color="error" variant="caption">
                            {errors.start}
                        </Typography>
                    )}
                </Grid>

                <Grid item xs={12} md={6}>
                    <DatePicker
                        views={dateType ? ["year", "month", "date"] : ["year", "month"]}
                        inputVariant="outlined"
                        margin="dense"
                        fullWidth
                        label="Fecha final"
                        format={dateType ? "DD/MM/yyyy" : "MM/yyyy"}
                        value={formData.dateFinish || null}
                        onChange={handleEndDateChange}
                    />
                    {errors.end && (
                        <Typography color="error" variant="caption">
                            {errors.end}
                        </Typography>
                    )}
                </Grid>
            </Grid>
        </>
    );
}